// src/models/DischargeModal.js
import React, { useEffect, useRef } from 'react';
// adjust this import path to where your DischargeSummary component actually lives
import DischargeSummary from "../pages/AddDischarge";

// ✅ Add global CSS for SweetAlert z-index fix
const swalStyles = `
  .swal2-container {
    z-index: 300000 !important;
  }
  .swal2-popup {
    z-index: 300001 !important;
  }
  .swal-above-modal {
    z-index: 300000 !important;
  }
  .swal-popup-above-modal {
    z-index: 300001 !important;
  }
`;

export default function DischargeModal({ patientData, onClose, onSaved }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    // ✅ Inject SweetAlert z-index styles
    const styleEl = document.createElement('style');
    styleEl.id = 'swal-modal-zindex-fix';
    styleEl.textContent = swalStyles;
    
    // Only add if not already present
    if (!document.getElementById('swal-modal-zindex-fix')) {
      document.head.appendChild(styleEl);
    }

    // disable page scroll while modal is open
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // simple focus trap: focus modal dialog
    const el = dialogRef.current;
    if (el) {
      const focusable = el.querySelector('button, a, input, textarea, select, [tabindex]:not([tabindex="-1"])');
      (focusable || el).focus?.();
    }

    return () => {
      document.body.style.overflow = prev || '';
      // Note: We don't remove the style element as other modals might need it
    };
  }, []);

  // Close when clicking backdrop (but not when clicking inside dialog)
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      if (typeof onClose === 'function') onClose();
    }
  };

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        WebkitOverflowScrolling: 'touch'
      }}
      aria-modal="true"
      role="dialog"
    >
      <div
        ref={dialogRef}
        role="document"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '95%',
          maxWidth: 1100,
          background: '#fff',
          borderRadius: 8,
          maxHeight: '92vh',
          overflow: 'hidden',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          zIndex: 100000,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          pointerEvents: 'auto'
        }}
        tabIndex={-1}
      >
        <div className="modal-header p-3 d-flex justify-content-between align-items-center" style={{ flex: '0 0 auto' }}>
          <h5 className="modal-title mb-0">Discharge Summary</h5>
          <button
            className="btn btn-sm btn-light"
            onClick={() => typeof onClose === 'function' && onClose()}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div
          className="modal-body p-3"
          style={{
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            padding: 12,
            flex: '1 1 auto'
          }}
        >
          <DischargeSummary
            patientData={patientData}
            onClose={onClose}
            onSaved={onSaved}
            modalMode={true}
          />
        </div>
      </div>
    </div>
  );
}